$(document).ready(function () {
  let $body = $('body');
  let $burgerBtn = $('.l-header__burger');
  let $sideMenu = $('.l-header__side');
  
  // サイドメニューの動作
  $burgerBtn.on('click', function () {
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $body.css('overflow', 'hidden');
      $sideMenu.fadeIn(300).css('display', 'flex');
    } else {
      $sideMenu.fadeOut(300);
      $body.css('overflow', '');
    }
  });
});
